var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Harddisk"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 40.635v1.365h4.586l6.655-6.655z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 56,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.94 36.1 10.634-5a1 1 0 0 1 1.133 1.612l-6.5 6.5a14.81 14.81 0 0 0 4.793.788 15.048 15.048 0 1 0 -10.06-3.9zm10.06-24.1a13.015 13.015 0 0 1 13 13 1 1 0 0 1 -2 0 11.013 11.013 0 0 0 -11-11 1 1 0 0 1 0-2zm0 9a4 4 0 1 1 -4 4 4 4 0 0 1 4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 48h18v6h-18z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 56,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 60h40a1 1 0 0 0 1-1v-54a1 1 0 0 0 -1-1h-40a1 1 0 0 0 -1 1v54a1 1 0 0 0 1 1zm31-4h-22v-10h22zm6 3a3 3 0 1 1 3-3 3 3 0 0 1 -3 3zm0-54a3 3 0 1 1 -3 3 3 3 0 0 1 3-3zm-17 3a17 17 0 0 1 0 34 16.714 16.714 0 0 1 -6.336-1.25l-2.957 2.957a1 1 0 0 1 -.707.293h-6a1 1 0 0 1 -1-1v-3a1 1 0 0 1 .574-.905l4.42-2.08a16.985 16.985 0 0 1 12.006-29.015zm-17-3a3 3 0 1 1 -3 3 3 3 0 0 1 3-3zm0 48a3 3 0 1 1 -3 3 3 3 0 0 1 3-3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdd);
export default __webpack_public_path__ + "static/media/hdd.9714623f5595b735ab9f46e0a399ab2a.svg";
export { ForwardRef as ReactComponent };